import { render, staticRenderFns } from "./CustomerCTAdd.vue?vue&type=template&id=4141bc2a&scoped=true"
import script from "./CustomerCTAdd.vue?vue&type=script&lang=js"
export * from "./CustomerCTAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4141bc2a",
  null
  
)

export default component.exports